import { Quill } from 'react-quill';

import 'components/Shared/Forms/RichTextEditor/Quill/Style';
import ColorPicker, { COLORS } from 'components/Shared/Forms/RichTextEditor/Quill/ColorPicker';
import FontPicker, { fillFontSelect } from 'components/Shared/Forms/RichTextEditor/Quill/FontPicker';
import FontSizePicker, { fillFontSizeSelect } from 'components/Shared/Forms/RichTextEditor/Quill/FontSizePicker';
import FontHeaderPicker, { FONT_HEADERS } from 'components/Shared/Forms/RichTextEditor/Quill/FontHeaderPicker';
import 'components/Shared/Forms/RichTextEditor/Quill/PlainClipboard';

const SnowTheme = Quill.import('themes/snow');

class SnazzyQuillTheme extends SnowTheme {
    buildPickers(selects, icons) {
        // 1. Create a custom picker
        const customPickers = selects
            .map((select) => {
                if (select.classList.contains('ql-color')) {
                    fillSelect(select, COLORS, '');
                    return new ColorPicker(select, icons.color);
                } else if (select.classList.contains('ql-font')) {
                    fillFontSelect(select);
                    return new FontPicker(select);
                } else if (select.classList.contains('ql-size')) {
                    fillFontSizeSelect(select);
                    return new FontSizePicker(select);
                } else if (select.classList.contains('ql-header')) {
                    fillSelect(select, FONT_HEADERS);
                    return new FontHeaderPicker(select);
                }
                return null;
            })
            .filter((x) => x != null);

        // 2. Create the default pickers, excluding the custom ones
        super.buildPickers(
            selects.filter((select) => !customPickers.some((custom) => custom.select === select)),
            icons
        );

        // 3. Splice the custom pickers into the default pickers
        customPickers.forEach((custom) => {
            const index = selects.findIndex((select) => custom.select === select);
            if (index !== -1) {
                this.pickers.splice(index, 0, custom);
            }
        });
    }
}

// Defined in themes/base.js in quilljs
const fillSelect = (select, values, defaultValue = false) => {
    values.forEach((value) => {
        const option = document.createElement('option');
        if (value === defaultValue) {
            option.setAttribute('selected', 'selected');
        } else {
            option.setAttribute('value', value);
        }
        select.appendChild(option);
    });
};

Quill.register({
    'themes/snazzy': SnazzyQuillTheme,
});
